<template>
  <div id="App">
    <NavigationMobile />
    <div class="content" :class="{ open: showNav }">
      <header class="site-header">
        <div class="container">
          <div class="logo animated fadeInLeft delay_1">
            <!-- <div class="logo"> -->
            <a
              href="https://www.cych.org.tw/cychwebsites/cychrwd/2640/index.html"
              title="嘉義基督教醫院自殺暨藥酒癮防治中心"
            >
              <!-- <v-img
            src="../src/assets/logo.png" class="img-responsive">
          </v-img>  -->
            </a>
          </div>
          <nav class="site-nav">
            <div
              id="navigation-icon"
              v-if="mobileView"
              @click="showNav = !showNav"
            >
              <i class="fas fa-bars"></i>
            </div>
            <Navigation v-if="!mobileView" />
          </nav>
        </div>
      </header>
      <Banner />
      <Content />
      <Footer />
      <!-- <v-toolbar color="cyan" dark id="scroll-target">
          <v-toolbar-side-icon></v-toolbar-side-icon>
          <v-toolbar-title>Scroll Down</v-toolbar-title>
        </v-toolbar> -->
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="toTop"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import NavigationMobile from "./components/NavigationMobile.vue";
import Navigation from "./components/Navigation.vue";
import Banner from "./components/Banner.vue";
import Content from "./components/Content.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Navigation,
    NavigationMobile,
    Banner,
    Content,
    Footer,
  },
  data: () => {
    return {
      mobileView: true,
      // showNav: false,
      wsdMsg: {
        NODE_ENV: process.env.NODE_ENV,
        VUE_APP_RUN: process.env.VUE_APP_RUN,
      },
      fab: false,
    };
  },
  computed: {
    // 漢堡選單及側開選單開關共用
    showNav: {
      // return this.$store.state.showNav
      get() {
        return this.$store.state.showNav;
      },
      set(x) {
        this.$store.commit("SET_SHOWNAV", x);
      },
    },
  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    // totop
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  created() {
    this.handleView();
    window.addEventListener("resize", this.handleView);
  },
};
</script>
<style lang="scss">
@import "./assets/css/reset.css";
@import "./assets/css/style.css";
#app {
  position: relative;
  width: 100%;
  height: calc(100vh-50px);
  overflow: hidden;
}

#navigation-icon {
  padding: 10px 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  i {
    font-size: 2rem;
  }
}
@media (max-width: 990px) {
  #navigation-icon {
    padding: 50px 30px 0px;
    cursor: pointer;
    i {
      font-size: 2rem;
    }
  }
}
@media (max-width: 640px) {
  .site-nav {
    margin-left: 20px;
    margin-top: 0px;
    padding: 0px;
    //background-color:#333;
  }
  #navigation-icon {
    padding: 50px 0 0;
    cursor: pointer;
    i {
      font-size: 2rem;
    }
  }
}
.content {
  position: absolute;
  top: 0px;
  width: 100%;
  background-color: rgb(255, 255, 255);
  height: calc(100vh-60px);
  margin: 0 auto;
  padding: 0;
  //background-color:#333;
  // transition: 1s transform cubic-bezier(0, 0.15, 0.08, 1);
}
.open {
  transform: translateX(180px);
}
</style>
